import { IndirectPaginatedAPIData, PaginatedAPIData } from 'utils/apidata';
import { emptyIndirectPaginatedAPIData } from 'Common/utilities/pagination';
import {
  ListProjectStaticFiltersRequest,
  getStaticFiltersKey,
} from 'stores/projects/generators/staticFilters';
import { getStore } from 'stores/common/selectors';
import { createSelector } from 'reselect';
import { pageNumberSelector } from 'stores/router/selectors';
import { StaticFilter } from '../models/staticFilters';

export function indirect(state: any): IndirectPaginatedAPIData<StaticFilter> {
  const store = getStore(state);
  return store.projects.staticFilters?.pages ?? emptyIndirectPaginatedAPIData;
}

export function pages(
  state: any,
  request: ListProjectStaticFiltersRequest
): PaginatedAPIData<StaticFilter> {
  const key = getStaticFiltersKey(request);
  return indirect(state)[key] ?? emptyIndirectPaginatedAPIData;
}

export const list = createSelector(
  [pages, pageNumberSelector],
  (page, pageNumber) => {
    if (page.isFilled && page.success) {
      const currentPage = page.pageResults[pageNumber];
      return currentPage?.isFilled && currentPage?.success
        ? currentPage.data.results
        : [];
    }
  }
);

export const hasNextPage = createSelector(pages, (page) => {
  if (page.isFilled && page.success) {
    return Boolean(page.nextPage);
  }
  return false;
});

export const isLoading = createSelector(pages, (page) => page.isLoading);

export const lastDeletedStaticFilter = (state: any) =>
  state.v2.projects.staticFilters.lastDeleted;
